export default __webpack_public_path__ + "static/media/shard-stigma-inactive.dc46811e.jpg";